import "./BottomAdvertisement.scss";
import images from "../../assets/images";
import { FC } from "react";

interface propsType {
  adImage: string;
  handlecloseAd? : () => void
  showcloseIcon ? : boolean
}
const BottomAdvertisement: FC<propsType> = ({ adImage, handlecloseAd, showcloseIcon }) => {
  const {closeIconround} = images
  return (
    <div className="bottomAdContainer">
      {adImage && (
        <>
          {" "}
          <img src={adImage} alt="adImage" className="bottomAdStyle" />
          {showcloseIcon && <img className="close-ad-button" onClick={handlecloseAd} alt="close" src={closeIconround}/>}
        </>
      )}
    </div>
  );
};

export default BottomAdvertisement;
